export const EVENT_TO_NAV_SECTION = {
  'talent:talent:created': '/talents',
  'talent:talent:deleted': '/talents',
  'talent:talent:status-changed': '/talents',
  'talent:talent:type-changed': '/talents',
  'talent:talent:stage-changed': '/talents',
  'talent:talent:manager-changed': '/talents',
  'talent:note:created': '/talents',
  'talent:job-application:created': '/job-applications',
  'talent:job-application:deleted': '/job-applications',
  'talent:talent-post:published': '/talent-posts',
  'talent:talent-post:unpublished': '/talent-posts',
  'talent:talent-post:deleted': '/talent-posts',
  'talent:playbook:started': '/stages-dashboard',
  'talent:playbook:step-due-soon': '/stages-dashboard',
  'talent:playbook:completed': '/stages-dashboard',
  'talent:playbook:cancelled': '/stages-dashboard',
  'talent:playbook:extended': '/stages-dashboard',
  'talent:playbook:overdue': '/stages-dashboard',
  'support:ticket:created': '/support/tickets',
  'support:ticket:resolved': '/support/tickets',
  'support:ticket:replied': '/support/tickets',
};

export function aggregateByNavSection(rawCounts) {
  const result = {};
  for (const { _id: eventType, section, count } of rawCounts) {
    // section: menu item the producer put in metadata.navSection (talent-service: Candidates › stage, …)
    const href = section || EVENT_TO_NAV_SECTION[eventType];
    if (href) result[href] = (result[href] || 0) + count;
  }
  return result;
}
